import { DATA_UPDATE_ROW, DATA_ROW_REMOVE, DATA_MARK_ERRORS_AS_DIRTY, DATA_UNDO, DATA_REDO, DATA_UNDO_ALL } from '../data/types';
import { undoableReducer } from '../../undoableReducer';
import { rowReducer } from '../data/reducers';
import { DETACHED_INIT, DETACHED_REMOVE } from './types';
const subReducer = undoableReducer(rowReducer, {
    actionTypes: [
        DATA_UPDATE_ROW,
        DATA_ROW_REMOVE,
        DATA_MARK_ERRORS_AS_DIRTY,
        DATA_UNDO,
        DATA_REDO,
        DATA_UNDO_ALL
    ],
    undoType: DATA_UNDO,
    undoAllType: DATA_UNDO_ALL,
    redoType: DATA_REDO
});
export const detachedRowReducer = (state = {}, action)=>{
    if (action.detachedId) {
        switch(action.type){
            case DETACHED_INIT:
                return {
                    ...state,
                    [action.detachedId]: {
                        past: [],
                        present: action.row,
                        future: []
                    }
                };
            case DETACHED_REMOVE:
                {
                    const stateCopy = {
                        ...state
                    };
                    delete stateCopy[action.detachedId];
                    return stateCopy;
                }
            case DATA_UPDATE_ROW:
            case DATA_ROW_REMOVE:
            case DATA_MARK_ERRORS_AS_DIRTY:
            case DATA_UNDO:
            case DATA_REDO:
            case DATA_UNDO_ALL:
                {
                    const detachedState = state?.[action.detachedId];
                    // Only continue if the detached row exists. When unmounting a detached row it is removed from the store and it can then happen that child components fail,
                    // e.g. ValidationGroupable, which also tries to update the store on unmount.
                    if (detachedState) {
                        return {
                            ...state,
                            [action.detachedId]: subReducer(detachedState, action)
                        };
                    }
                }
        }
    }
    return state;
};
